import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { getPowerBiReportInformation } from "./service";
import { menuMonitoring } from "./constants";
import { IPowerBiReport, IPowerBiReportResponse } from "./interfaces";
import "./style.css";

function PBIDashboardComponent() {
  // extract "id" key from url params
  const { id } = useParams();

  const [reportLoadConfig, setReportLoadConfig] = useState<any | null>(null);

  const [reportPage, setReportPage] = useState<string | null>(null);

  const [isError, setIsError] = useState<boolean>(false);

  /** Effect :- call api to get power bi report config  */
  useEffect(() => {
    if (id) {
      // find out report
      const reportInfo = menuMonitoring
        .filter((x) => x.id === id)
        .firstOrDefault();

      // check is report has report id and current id belongs to it
      if (reportInfo && reportInfo.hasOwnProperty("reportId")) {
        // api call to get embending information
        getPowerBiReportInformation({
          id: reportInfo?.reportId as any,
        })
          .then((response: IPowerBiReportResponse) => {
            if (response?.reportId) {
              prepareReportConfig(reportInfo, response);
            } else {
              setIsError(true);
            }
          })
          .catch(() => {
            setIsError(true);
          });
      }
    }
  }, [id]);

  /** Effect :- Prepare power bi report config  */
  const prepareReportConfig = (
    reportInfo: IPowerBiReport,
    response: IPowerBiReportResponse,
  ) => {
    // check is report has report id and current id belongs to it
    if (reportInfo?.reportId) {
      // check is filter are available
      const filterByParam = reportInfo?.filterColumn
        ? reportInfo?.filterColumn
        : "";

      // set report page if available
      const pageName = reportInfo?.pages?.firstOrDefault()?.ReportSection;

      // prepare filter definition
      const predefinedFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1,
        target: {
          table: reportInfo?.tableName ? reportInfo?.tableName : null,
          column: reportInfo?.filterColumn ? reportInfo?.filterColumn : null,
        },
        operator: "In",
        values: [filterByParam],
      };

      // power- bi report configuration
      const config = {
        type: "report", // Supported types: report, dashboard, tile, visual and qna
        id: reportInfo.reportId,
        embedUrl: response?.url,
        accessToken: response?.token,
        tokenType: models.TokenType.Embed,
        permissions: models.Permissions.Read,
        pageName: pageName ? pageName : null,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
        },
        filters: filterByParam == "" ? [] : [predefinedFilter],
      };

      setReportLoadConfig(config);
    }
  };

  return (
    <>
      <div>
        {reportLoadConfig?.hasOwnProperty("type") ? (
          <PowerBIEmbed
            embedConfig={reportLoadConfig}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function() {
                    console.log("Report loaded");
                  },
                ],
                [
                  "rendered",
                  function() {
                    console.log("Report rendered");
                  },
                ],
                [
                  "error",
                  function(event: any) {
                    console.log(event.detail);
                  },
                ],
              ])
            }
            cssClassName={"embed-power-bi-style"}
            getEmbeddedComponent={(embeddedReport: any) => {
              (window as any).report = embeddedReport;
            }}
          />
        ) : (
          <div className="empty-report">
            {isError && (
              <h3 style={{ backgroundColor: "yellow", marginTop: "50px" }}>
                The dashboard is currently undergoing maintenance and will be
                back online soon. Thank You for your patience!
              </h3>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default PBIDashboardComponent;
